<template>
  <div class="top-section">
    <div class="top-section__container container-new">
      <div class="top-section__info">
        <h5
          class="txt--bold txt--36px txt--60px--m txt--height-44px txt--height-72px--m txt--color-04 mb-20 mb-24--l"
        >
          {{ $t('business.topSection.title') }}
        </h5>
        <p
          class="txt--weight-500 txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-03 mb-0"
        >
          {{ $t('business.topSection.desc') }}
        </p>
      </div>
      <img
        class="top-section__image"
        src="@/assets/img/business/top-section/img.svg"
        width="100%"
        alt="bag image"
      >
      <div class="top-section__btns">
        <button-with-arrow
          full-width
          size="l"
          class="top-section__btn"
          :to="localePath('/network')"
        >
          {{ $t('business.topSection.tokenBtn') }}
        </button-with-arrow>
        <exc-button
          class="top-section__btn"
          size="l"
          outline
          color="dark"
          full-width
          :to="localePath('/about-us')"
        >
          {{ $t('business.topSection.exchangeBtn') }}
        </exc-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'

export default {
  name: 'TopSection',
  components: {
    ExcButton,
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
}
</script>

<style lang="scss" scoped>
.top-section {
  &__container {
    padding-top: toRem(20px);
    padding-bottom: toRem(20px);
    display: grid;
    grid-template-areas: 'info' 'image' 'btns';
    gap: toRem(20px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-areas: 'info image' 'btns image';
    }

    @include bp(l) {
      row-gap: toRem(48px);
    }
  }

  &__info {
    grid-area: info;

    @include bp(m) {
      margin: auto 0 0 0;
    }
  }

  &__image {
    grid-area: image;

    @include bp(0, m) {
      margin: 0 auto;
    }

    max-width: toRem(580px);
  }

  &__btn {
    @include bp(l) {
      max-width: fit-content;
    }
  }

  &__btns {
    grid-area: btns;
    display: flex;
    flex-direction: column;
    gap: toRem(16px);

    @include bp(m) {
      margin: 0 0 auto 0;
    }

    @include bp(l) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
}
</style>
